export const reviews = [
  {
    id: 'nicci-french-fearsomely',
    text: 'A fearsomely good thriller',
    source: 'Nicci French, House of Correction',
    featured: true,
  },
  {
    id: 'sd-sykes',
    text: 'Psychological thriller at its very best',
    source: 'SD Sykes, the Oswald de Lacy Books',
    featured: true,
  },
  {
    id: 'closer-hooked',
    text: 'Fans of psychological thrillers will be hooked after the first page',
    source: 'CLOSER',
    featured: true,
  },
  {
    id: 'ba-paris-therapist',
    text: 'Compulsive, edgy and fabulous twists!',
    source: 'B A Paris, The Therapist',
    featured: true,
  },
  {
    id: 'cara-hunter',
    text: 'Few writers can match Jane Corry',
    source: 'Cara Hunter, The Whole Truth',
    featured: true,
  },
  {
    id: 'lj-ross',
    text: 'Suspense, thrills and intelligent storytelling. I highly recommend it!',
    source: 'LJ Ross, The DCI Ryan Mysteries',
    featured: true,
  },
  {
    id: 'kate-hamer',
    text: 'This twisty tale of love and revenge is a compulsive read',
    source: 'Kate Hamer, Crushed',
    featured: true,
  },
  {
    id: 'kate-furnivall-guardian',
    text: 'A powerful and addictive read',
    source: 'Kate Furnivall, The Guardian of Lies',
    featured: true,
  },
  {
    id: 'kate-furnivall-queen',
    text: 'Jane Corry is the new queen of the psychological thriller',
    source: 'Kate Furnivall',
    featured: true,
  },
  {
    id: 'ba-paris-twists',
    text: "Compulsive, edgy and with some fabulous twists that I didn't see coming!",
    source: 'B A Paris',
    featured: true,
  },
  {
    id: 'elizabeth-haynes',
    text: 'A roller-coaster of dramatic twists . . . chilling and suspenseful',
    source: 'Elizabeth Haynes',
    featured: true,
  },

  {
    id: 'phoebe-morgan',
    text: 'Jane Corry is at the top of her game and her latest novel cements her place as one of the superstars of the genre',
    source: 'Phoebe Morgan',
    featured: true,
  },
  {
    id: 'ok-magazine',
    text: "A chilling maze of twists and turns, bestseller Jane Corry's latest thriller will have you hooked from page one",
    source: 'OK',
    featured: true,
  },
  {
    id: 'gillian-mcallister',
    text: 'Corry often explores darker themes, and those living on the fringes of society and this book is no exception: gritty, real, interesting and clever. Highly recommended',
    source: 'Gillian McAllister',
    featured: true,
  },
  {
    id: 'teresa-driscol',
    text: 'What an addictive read! Extremely clever storytelling with terrific pace and real emotional depth too. I loved it',
    source: 'Teresa Driscol',
    featured: true,
  },
  {
    id: 'adele-parks',
    text: 'Sensitive and thought-provoking',
    source: 'Adele Parks',
    featured: true,
  },
  {
    id: 'claire-douglas',
    text: 'So many brilliant twists',
    source: 'Claire Douglas',
    featured: true,
  },
  {
    id: 'eva-dolan',
    text: 'Twisty, feverish and utterly gripping',
    source: 'Eva Dolan',
    featured: true,
  },
  {
    id: 'peter-james',
    text: 'Beautifully written',
    source: 'Peter James',
    featured: true,
  },

  {
    id: 'red-magazine',
    text: 'Tense, taut and twisty',
    source: 'RED',
    featured: true,
  },
];
